module.exports = __webpack_public_path__ + "img/D201510_4.140a6c23.jpg";